import { INSURANCE_TYPES, TIME_OPTIONS, TIME_OPTIONS_FULL, TIME_OPTIONS_WORK } from "@global/const";

const M = {
    id: '',
    displayed_network: '',
    name: '',
    city: '',
    area: '',
    locality: '',
    district: '',
    address: '',
    metros: [],
    reportOn: false,
    reportTo: '',
    reportCc: '',
    reportMessage: '',
    reportToName: '',

    img: '',
    imgOriginalPath: '',
    mapZoom: 16,
    markLat: 0,
    markLong: 0,
    types: [],
    url: '',

    workTime: {
        monFrom: '',
        monTill: '',
        tueFrom: '',
        tueTill: '',
        wedFrom: '',
        wedTill: '',
        thuFrom: '',
        thuTill: '',
        friFrom: '',
        friTill: '',
        satFrom: '',
        satTill: '',
        sunFrom: '',
        sunTill: '',
    },
    nameOfficial: '',
    licenceNum: '',

    searchMetros: [],
    searchMetrosManual: [],
    moderationNeeded: false,
    proprietary: "",
    chiefDoctor: '',
    estYear: '',
    insuranceType: '',
    hasTerminal: 0,
    hasHospital: 0,
    hasLaboratory: 0,
    hasParking: 0,
    description: '',
    photos: [],
    licences: [],
    hasActiveSubscription: false,
}

export function GET_DEFAULT_M () { return JSON.parse(JSON.stringify(M));}
export function  initialState() { return JSON.parse(JSON.stringify(
    {
            M: M,
            insuranceTypes: INSURANCE_TYPES,
            timeOptionsMon: TIME_OPTIONS,
            timeOptionsTue: TIME_OPTIONS,
            timeOptionsWed: TIME_OPTIONS,
            timeOptionsThu: TIME_OPTIONS,
            timeOptionsFri: TIME_OPTIONS,
            timeOptionsSat: TIME_OPTIONS,
            timeOptionsSun: TIME_OPTIONS,
            timeOptionsFull: TIME_OPTIONS_FULL,
            timeOptionsWork: TIME_OPTIONS_WORK,
            yMap: null,
            yMapPlacemark: null,
            Mhashcode: null,
            buffClinicCity: '',
            buffClinicAddress: '',
            buffClinicLocality: '',
    }
));}
